import { Injectable } from '@angular/core';
// third party imports
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { ChoiceComponent } from '../modals/choice/choice.component';
import { AddEditContactComponent } from 'src/app/accounting/modals/add-edit-contact/add-edit-contact.component';
import { SalesReceiptPrintComponent } from 'src/app/accounting/sales-receipt-print/sales-receipt-print.component';
import { SerialNumberListComponent } from '../modals/serial-number-list/serial-number-list.component';
import { ScanIdComponent } from '../modals/scan-id/scan-id.component';
import { LiveVendorData } from '../models/vendor';
import { InventoryOptionsComponent } from '../modals/inventory-options/inventory-options.component';
import {
  InventoryAlert,
  AutoPurchase,
  BoundBookEntry,
  Firearm,
} from '../models/general';
import { FflSearchComponent } from '../modals/ffl-search/ffl-search.component';
import { AtfFfl } from '../models/atf-ffl';
import { DriverLicense } from '../models/drivers-license-parser';
import { FirearmManagementEditComponent } from 'src/app/firearms/firearm-management/modals/firearm-management-edit/firearm-management-edit.component';
import { DriversLicenseSelectionComponent } from '../modals/drivers-license-selection/drivers-license-selection.component';
import { DuplicateTtsnComponent } from '../modals/duplicate-ttsn/duplicate-ttsn.component';
import { CompetitorPricingComponent } from 'src/app/vendor-data/vendor-dashboard/modals/competitor-pricing/competitor-pricing.component';
import { DispoBuildComponent } from '../modals/dispo-build/dispo-build.component';
import { User } from '../models/company';
import {
  SalesReceipt,
  ProductServiceItem,
  SalesItem,
  Customer,
  Vendor,
} from '../models/accounting';
import { ModalID } from '../models/constants';
import { ModalType } from '../models/constants';

// Modals
import { MessageComponent } from '../modals/message/message.component';
import { YesNoComponent } from '../modals/yes-no/yes-no.component';
import { FirearmInfoDashComponent } from '../components/firearm-info-dash/firearm-info-dash.component';
import { EditBbFirearmComponent } from '../modals/edit-bb-firearm/edit-bb-firearm.component';
import { EditBbAcquisitionComponent } from '../modals/edit-bb-acquisition/edit-bb-acquisition.component';
import { QuestionnaireIntoComponent } from '../../form-4473/modals/questionnaire-into/questionnaire-into.component';
import { DigitalSignatureComponent } from '../modals/digital-signature/digital-signature.component';
import { AddEditUsersComponent } from '../../account-info/modals/add-edit-users/add-edit-users.component';
import { CreateProductServiceComponent } from '../modals/create-product-service/create-product-service.component';
import { ImportByCategoryComponent } from '../../accounting/products-services/modals/import-by-category/import-by-category.component';
import { UserCredentialsComponent } from '../modals/user-credentials/user-credentials.component';
import { AddEditEventComponent } from '../../calendar/modals/add-edit-event/add-edit-event.component';
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  dispo_build_modal_shown = false;
  constructor(private modalService: BsModalService) {}
  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  modalOptions: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    class: 'modal-dialog  modal-dialog-centered',
  } as any;

  //----------------Modal functions---------------------
  closeModal(modalId: number) {
    this.modalService.hide(modalId);
  }
  // openStatusModal(status: string, indicator: string) {
  //   this.modalOptions = {
  //     initialState: {
  //       status: status,
  //       indicator: indicator,
  //     } as any,
  //     ignoreBackdropClick: true,
  //     keyboard: false,
  //     class: 'modal-dialog, modal-dialog-centered',
  //   };
  //   this.modalRef = this.modalService.show(
  //     StatusComponent,
  //     Object.assign({ id: ModalID.status }, this.modalOptions),
  //   );
  // }
  openMessageModal(message: string, error?: boolean) {
    this.modalOptions = {
      id: ModalID.message,
      initialState: {
        message: message,
        error: error,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      MessageComponent,
      Object.assign({ id: ModalID.status }, this.modalOptions),
    );
  }
  openYesNoModal(
    question: string,
    optional_details?: {},
    reverse_buttons?: boolean,
  ) {
    this.modalOptions = {
      initialState: {
        question: question,
        optional_details: optional_details ? optional_details : {},
        reverse_btn_color: reverse_buttons ? reverse_buttons : false,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      YesNoComponent,
      Object.assign({ id: ModalID.yes_no }, this.modalOptions),
    );
  }
  openFirearmInfoDash(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.firearm_info_dash,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      FirearmInfoDashComponent,
      Object.assign({ id: ModalID.firearm_info_dash }, this.modalOptions),
    );
  }
  openEditBoundBookFirearm(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.edit_bb_firearm,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      EditBbFirearmComponent,
      Object.assign({ id: ModalID.edit_bb_firearm }, this.modalOptions),
    );
  }
  openEditBoundBookAcquisition(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.edit_bb_acquisition,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal_edit_acquisition',
    };
    this.modalRef = this.modalService.show(
      EditBbAcquisitionComponent,
      Object.assign({ id: ModalID.edit_bb_acquisition }, this.modalOptions),
    );
  }
  openQuestionnaireIntro() {
    this.modalOptions = {
      id: ModalID.questionnaire_intro,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      QuestionnaireIntoComponent,
      Object.assign({ id: ModalID.questionnaire_intro }, this.modalOptions),
    );
  }
  openDigitalSignature() {
    this.modalOptions = {
      id: ModalID.digital_signature,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      DigitalSignatureComponent,
      Object.assign({ id: ModalID.digital_signature }, this.modalOptions),
    );
  }
  openAddEditUser(modal_type: string, selected_user?: User) {
    this.modalOptions = {
      id: ModalID.add_edit_users,
      initialState: {
        selected_user: selected_user,
        modal_type: modal_type,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      AddEditUsersComponent,
      Object.assign({ id: ModalID.add_edit_users }, this.modalOptions),
    );
  }
  openCreateProductService(
    modal_type: string,
    item: ProductServiceItem,
    rowIndex?: number,
    component?: string,
  ) {
    this.modalOptions = {
      id: ModalID.add_edit_product_service,
      initialState: {
        modal_type: modal_type,
        item: item,
        row_index: rowIndex,
        calling_component: component,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    console.warn(this.modalOptions);
    this.modalRef = this.modalService.show(
      CreateProductServiceComponent,
      Object.assign(
        { id: ModalID.add_edit_product_service },
        this.modalOptions,
      ),
    );
  }
  openChoiceModal(question: string, optional_details: {}, options: string[]) {
    this.modalOptions = {
      id: ModalID.choice,
      initialState: {
        question: question,
        options: options,
        optional_details: optional_details,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      ChoiceComponent,
      Object.assign({ id: ModalID.choice }, this.modalOptions),
    );
  }
  openAddEditContactModal(
    modal_type: string,
    contact_type: string,
    contact?: any,
    rowIndex?: number,
  ) {
    this.modalOptions = {
      id: ModalID.add_edit_contact,
      initialState: {
        modal_type: modal_type,
        customer: contact as Customer,
        vendor: contact as Vendor,
        rowIndex: rowIndex,
        contact_type: contact_type,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      AddEditContactComponent,
      Object.assign({ id: ModalID.add_edit_contact }, this.modalOptions),
    );
  }
  openSalesReceiptPrintModal(sales_receipt: SalesReceipt) {
    this.modalOptions = {
      id: ModalID.sales_receipt_print,
      initialState: {
        sales_receipt: sales_receipt,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      SalesReceiptPrintComponent,
      Object.assign({ id: ModalID.sales_receipt_print }, this.modalOptions),
    );
    console.log('oping the sales receipt print modal');
  }
  openSerialNumberModal(
    item_count: number,
    saleItem: SalesItem,
    rowIndex?: number,
  ) {
    this.modalOptions = {
      id: ModalID.firearm_serial_number_list,
      initialState: {
        item_count: item_count,
        saleItem: saleItem,
        rowIndex: rowIndex,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      SerialNumberListComponent,
      Object.assign({ id: ModalID.sales_receipt_print }, this.modalOptions),
    );
    console.log('opening the serial number list modal');
  }
  openScanIdModal() {
    this.modalOptions = {
      id: ModalID.scan_id,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      ScanIdComponent,
      Object.assign({ id: ModalID.scan_id }, this.modalOptions),
    );
    console.log('opening the scan ID modal2');
  }
  openInventoryOptionsModal(
    type?: string,
    modal_type?: string,
    row_data?: any,
    item_data?: { upc?: string; name?: string; description?: string },
  ) {
    this.modalOptions = {
      id: ModalID.inventory_options,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    if (type === 'auto_purchase') {
      this.modalOptions.initialState = {
        modal_type: modal_type,
        auto_purchase_selected_row: row_data,
        request_type: 'auto_purchase',
        prefill_item_data: item_data,
      } as any;
    } else {
      this.modalOptions.initialState = {
        modal_type: modal_type,
        alert_selected_row: row_data,
        request_type: type,
        prefill_item_data: item_data,
      } as any;
    }
    this.modalRef = this.modalService.show(
      InventoryOptionsComponent,
      Object.assign({ id: ModalID.inventory_options }, this.modalOptions),
    );
  }
  openImportVendorInventoryModal() {
    this.modalOptions = {
      id: ModalID.import_vendor_inventory,
      // initialState: {
      //   categories: categories,
      // } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      ImportByCategoryComponent,
      Object.assign({ id: ModalID.import_vendor_inventory }, this.modalOptions),
    );
  }
  openFflSearchModal() {
    const modalOptions: ModalOptions = {
      id: ModalID.ffl_search,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-ffl-search',
    };
    this.modalRef = this.modalService.show(
      FflSearchComponent,
      Object.assign({ id: ModalID.ffl_search }, modalOptions),
    );
  }
  openDispoBuildModal(component: string) {
    this.dispo_build_modal_shown = true;
    const modalOptions: ModalOptions = {
      initialState: {
        selected_component: component,
      },
      id: ModalID.dispo_build,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-ffl-search',
    };
    this.modalRef = this.modalService.show(
      DispoBuildComponent,
      Object.assign({ id: ModalID.dispo_build }, modalOptions),
    );
  }
  addEditFirearmClick(
    modal_type: string,
    row_data?: Firearm,
    rowIndex?: number,
    component?: string,
  ) {
    const modalOptions: ModalOptions = {
      initialState: {
        modal_type: modal_type,
        selected_row:
          modal_type === ModalType.edit || row_data.firearm_upc
            ? row_data
            : null,
        row_index: rowIndex,
        calling_component: component,
      } as any,
      ignoreBackdropClick: true,
      // backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered, modal-lg',
    };
    console.warn(modalOptions);
    this.modalRef = this.modalService.show(
      FirearmManagementEditComponent,
      Object.assign({ id: ModalID.firearm_management_edit }, modalOptions),
    );
  }
  openUserCredentials(ok_button_label: string, cancel_button_label: string) {
    const modalOptions: ModalOptions = {
      id: ModalID.user_credentials,
      ignoreBackdropClick: true,
      initialState: {
        ok_button: ok_button_label,
        cancel_button: cancel_button_label,
      },
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered ',
    };
    this.modalRef = this.modalService.show(
      UserCredentialsComponent,
      Object.assign({ id: ModalID.user_credentials }, modalOptions),
    );
  }
  openIdSelectionModal() {
    const modalOptions: ModalOptions = {
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-id-selection',
    };
    this.modalRef = this.modalService.show(
      DriversLicenseSelectionComponent,
      Object.assign({ id: ModalID.drivers_license_selection }, modalOptions),
    );
  }
  openDuplicateTTSNSelectionModal(id: string) {
    const modalOptions: ModalOptions = {
      initialState: {
        form4473Id: id,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-duplicate-ttsn',
    };
    this.modalRef = this.modalService.show(
      DuplicateTtsnComponent,
      Object.assign({ id: ModalID.duplicate_ttsn }, modalOptions),
    );
  }
  openCompetitorPricingModal(
    pricing_data: CompetitorPricing[],
    distributor_price: string,
  ) {
    //
    const modalOptions: ModalOptions = {
      initialState: {
        pricing_data: pricing_data,
        distributor_price: +distributor_price,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered, modal-competitor-pricing',
    };
    this.modalRef = this.modalService.show(
      CompetitorPricingComponent,
      Object.assign({ id: ModalID.competitor_pricing }, modalOptions),
    );
  }
  openAddEditEventModal(date?: Date, event?: any) {
    const modalOptions: ModalOptions = {
      initialState: {
        event_data: { date: date, event: event },
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      AddEditEventComponent,
      Object.assign({ id: ModalID.add_edit_event }, modalOptions),
    );
  }
}
export class CompetitorPricing {
  offer_id: string;
  name: string;
  price: number;
  vendor: string;
  shipping: string;
  url: string;
  is_available: boolean;
}
